import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../components/Navbar'

export default function EditTask() {
  const { taskId } = useParams()
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [instructions, setInstructions] = useState('')
  const [file, setFile] = useState(null)
  const [mediaUrl, setMediaUrl] = useState(null)
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => { fetchTask() }, [])

  async function fetchTask() {
    const { data } = await supabase.from('interventions').select('*').eq('id', taskId).single()
    if (data) {
      setTitle(data.title || '')
      setDescription(data.description || '')
      setInstructions(data.instructions || '')
      setMediaUrl(data.media_url || null)
    }
    setLoading(false)
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setSaving(true)
    setError('')
    let media_url = mediaUrl

    if (file) {
      const ext = file.name.split('.').pop()
      const filename = Date.now() + '.' + ext
      const { error: uploadError } = await supabase.storage.from('exercises').upload(filename, file)
      if (uploadError) { setError(uploadError.message); setSaving(false); return }
      const { data: urlData } = supabase.storage.from('exercises').getPublicUrl(filename)
      media_url = urlData.publicUrl
    }

    const { error: updateError } = await supabase
      .from('interventions')
      .update({ title, description, instructions, media_url })
      .eq('id', taskId)

    if (updateError) { setError(updateError.message); setSaving(false); return }
    navigate('/clinician/interventions')
  }

  async function handleRemoveMedia() {
    setMediaUrl(null)
    await supabase.from('interventions').update({ media_url: null }).eq('id', taskId)
  }

  if (loading) return <><Navbar /><div className="page"><p>Loading...</p></div></>

  return (
    <>
      <Navbar />
      <div className="page">
        <span onClick={() => navigate('/clinician/interventions')} className="back-link" style={{ cursor: 'pointer' }}>← Task library</span>
        <div className="page-header">
          <h1>Edit task</h1>
          <p>Update the details for this task</p>
        </div>

        {error && <div className="alert-error" style={{ marginBottom: '1.5rem' }}>{error}</div>}

        <div className="card">
          <form onSubmit={handleSubmit} className="form-group">
            <div className="form-field">
              <label className="form-label">Task title</label>
              <input placeholder="e.g. Ice therapy" value={title} onChange={e => setTitle(e.target.value)} required />
            </div>
            <div className="form-field">
              <label className="form-label">Short description</label>
              <textarea placeholder="Brief summary" value={description} onChange={e => setDescription(e.target.value)} rows={2} style={{ resize: 'vertical' }} />
            </div>
            <div className="form-field">
              <label className="form-label">Instructions</label>
              <textarea placeholder="Step-by-step instructions..." value={instructions} onChange={e => setInstructions(e.target.value)} rows={5} style={{ resize: 'vertical' }} />
            </div>
            <div className="form-field">
              <label className="form-label">Image (optional)</label>
              {mediaUrl && (
                <div style={{ marginBottom: 8 }}>
                  <img src={mediaUrl} alt="Current media" style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }} />
                  <button type="button" className="danger" onClick={handleRemoveMedia}>Remove image</button>
                </div>
              )}
              <input type="file" accept="image/png,image/jpeg" onChange={e => setFile(e.target.files[0])} />
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
              <button type="submit" disabled={saving} style={{ flex: 1, padding: 14 }}>
                {saving ? 'Saving...' : 'Save changes'}
              </button>
              <button type="button" className="secondary" onClick={() => navigate('/clinician/interventions')} style={{ padding: 14 }}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
